// Container
const DefaultContainer = () => import('@/containers/DefaultContainer')
// Other Components

// Management
const ManageClientStatusList = () => import('@/modules/status/views/management/ManageClientStatusList')


var routes = [
    {
        path: '/client-status',
        redirect: '/client-status/manage/list',
        name: 'Client Status',
        component: DefaultContainer,
        children: [
            // Client Status
            {
                path: 'manage/list',
                name: 'Manage Client Status List',
                component: ManageClientStatusList,
                meta: {
                    requiresAuth: true,
                    permission: false,
                },
            },
        ]
    },

];

export default routes;
